import React, {Component} from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import DOMUtils from '@spothero/utils/dom';

class RenderInBody extends Component {
    componentDidMount() {
        const {
            className
        } = this.props;

        this.container = document.createElement('div');

        if (className) {
            DOMUtils.addClass(this.container, className);
        }

        document.body.appendChild(this.container);

        this._renderLayer();
    }

    componentDidUpdate(prevProps, prevState) {
        this._renderLayer();
    }

    componentWillUnmount() {
        ReactDOM.unmountComponentAtNode(this.container);
        document.body.removeChild(this.container);
    }

    _renderLayer() {
        const {
            store,
            children
        } = this.props;

        if (store) {
            ReactDOM.render(
                <Provider store={store}>
                    {children}
                </Provider>,
            this.container);
        } else {
            ReactDOM.render(children, this.container);
        }
    }

    render() {
        return null;
    }
}

RenderInBody.propTypes = {
    className: PropTypes.string,
    children: PropTypes.element.isRequired,
    store: PropTypes.object
};

export default RenderInBody;



// WEBPACK FOOTER //
// ./frontend/src/js/components/common/RenderInBody.jsx